<app-modal-shell [showFooter]="editing()"
  (dismiss)="closeProfile()">
  <div modalTitle>
    <span class="profile-workspace__eyebrow">{{ 'profileWorkspace.title' | translate }}</span>
    <h1>{{ user()?.displayName || ('profileWorkspace.title' | translate) }}</h1>
  </div>
  <p modalDescription>
    {{ user()?.email }} · {{ organizationName() }}
  </p>

  <div modalHeaderActions>
    @if (!editing()) {
      <button class="profile-button profile-button--ghost"
        type="button"
        (click)="startEditing()">
        {{ 'general.edit' | translate }}
      </button>
    }
  </div>

  <section class="profile-workspace profile-workspace--dialog">
    <div class="profile-workspace__content">
      <div class="profile-workspace__scroll">
        <article class="profile-card profile-card--summary">
          <div class="profile-summary">
            <div class="profile-summary__avatar">
              @if (editing()) {
                @if (user()?.image) {
                  <div class="profile-summary__avatar-edit">
                    <ion-avatar class="profile-avatar">
                      <img [src]="user()?.image" />
                    </ion-avatar>
                    <button class="profile-avatar__remove"
                      type="button"
                      (click)="removeImage()">
                      <ion-icon name="refresh-outline"></ion-icon>
                    </button>
                  </div>
                } @else if (user()) {
                  <ion-avatar class="profile-avatar editing">
                    <app-pick-media [imageOnly]="true"
                      [accept]="'image/*'"
                      [name]="user()?.guid"
                      (filesSelected)="onFilesSelected($event)"
                      (imageUrl)="onImageUrl($event)"></app-pick-media>
                  </ion-avatar>
                }
              } @else if (user()?.image) {
                <ion-avatar class="profile-avatar">
                  <img [src]="user()?.image" />
                </ion-avatar>
              } @else {
                <div class="profile-avatar profile-avatar--fallback">
                  <ion-icon name="person-outline"></ion-icon>
                </div>
              }
            </div>

            <div class="profile-summary__meta">
              <div class="profile-summary__name-block">
                <strong>{{ user()?.displayName }}</strong>
                <span>{{ user()?.email }}</span>
              </div>

              <div class="profile-summary__chips">
                <span>{{ 'users.roles.' + user()?.role | translate }}</span>
                <span>{{ organizationName() }}</span>
              </div>

              @if (editing() && formGroup(); as profileForm) {
                <div class="profile-edit-grid">
                  <label class="profile-field">
                    <span>{{ 'item.name' | translate }}</span>
                    <ion-item lines="none">
                      <ion-input [formControl]="control('displayName')"></ion-input>
                    </ion-item>
                  </label>

                  <label class="profile-field">
                    <span>{{ 'item.phone' | translate }}</span>
                    <ion-item lines="none">
                      <ion-input type="tel"
                        [formControl]="control('phone')"></ion-input>
                    </ion-item>
                  </label>

                  <label class="profile-field profile-field--full">
                    <span>{{ 'item.email' | translate }}</span>
                    <div class="profile-static-field">
                      <strong>{{ profileForm.get('email')?.value }}</strong>
                      <button class="profile-button profile-button--ghost"
                        type="button"
                        (click)="changeEmail()">
                        {{ 'general.change' | translate }}
                      </button>
                    </div>
                  </label>
                </div>
              } @else {
                <div class="profile-summary__actions">
                  <button class="profile-button profile-button--ghost"
                    type="button"
                    (click)="changeEmail()">
                    {{ 'profileWorkspace.changeEmail' | translate }}
                  </button>
                </div>
              }
            </div>
          </div>
        </article>

        <article class="profile-card">
          <div class="profile-card__header">
            <div>
              <h2>{{ 'profileWorkspace.settings.title' | translate }}</h2>
              <p>{{ 'profileWorkspace.settings.description' | translate }}</p>
            </div>
          </div>

          <div class="profile-settings-grid">
            <div class="profile-setting">
              <div class="profile-setting__copy">
                <span>{{ 'profileWorkspace.settings.languageTitle' | translate }}</span>
                <small>{{ 'profileWorkspace.settings.languageDescription' | translate }}</small>
              </div>
              @if (currentLang$ | async; as lang) {
                <label class="profile-select">
                  <app-select-popover [value]="lang"
                    (change)="onLanguageSelect($event)">
                    @for (langItem of langs; track langItem) {
                      <ion-select-option [value]="langItem">
                        {{ 'langs.' + langItem | translate }}
                      </ion-select-option>
                    }
                  </app-select-popover>
                </label>
              }
            </div>

            <div class="profile-setting">
              <div class="profile-setting__copy">
                <span>{{ 'profileWorkspace.settings.accentColorTitle' | translate }}</span>
                <small>{{ 'profileWorkspace.settings.accentColorDescription' | translate }}</small>
              </div>
              <label class="profile-select">
                <app-select-popover [value]="currentAccentColor()"
                  (change)="onAccentColorSelect($event)">
                  @for (accent of availableAccentColors(); track accent.value) {
                    <ion-select-option [value]="accent.value">
                      {{ accent.label }}
                    </ion-select-option>
                  }
                </app-select-popover>
              </label>
            </div>

            <label class="profile-toggle-card">
              <div>
                <strong>{{ 'profileWorkspace.settings.morningDigestTitle' | translate }}</strong>
                <span>{{ 'profileWorkspace.settings.morningDigestDescription' | translate }}</span>
              </div>
              <ion-toggle [checked]="user()?.morningDigest !== false"
                (ionChange)="onMorningDigestToggle($event)"></ion-toggle>
            </label>

            <div class="profile-toggle-card profile-toggle-card--static">
              <div>
                <strong>{{ 'profileWorkspace.settings.notificationsTitle' | translate }}</strong>
                <span>{{ 'profileWorkspace.settings.notificationsDescription' | translate }}</span>
              </div>
              <ion-toggle [checked]="true"
                [disabled]="true"></ion-toggle>
            </div>


          </div>

        </article>



        <article class="profile-card">
          <div class="profile-card__header">
            <div>
              <h2>{{ 'profileWorkspace.security.title' | translate }}</h2>
              <p>{{ 'profileWorkspace.security.description' | translate }}</p>
            </div>
          </div>

          <div class="profile-security">
            <div class="profile-security__actions">
              <button class="profile-button profile-button--ghost"
                type="button"
                (click)="showPasswordForm.set(!showPasswordForm())">
                {{ showPasswordForm() ?
              ('profileWorkspace.security.hidePasswordChange' | translate) : ('general.changePassword' | translate) }}
              </button>
              <button class="profile-button profile-button--ghost"
                type="button"
                (click)="changeEmail()">
                {{ 'profileWorkspace.changeEmail' | translate }}
              </button>
              <button class="profile-button profile-button--ghost"
                type="button"
                (click)="logout()">
                {{ 'logout.title' | translate }}
              </button>
            </div>

            @if (showPasswordForm()) {
              <form class="profile-password-form"
                [formGroup]="passwordFormGroup()">
                <label class="profile-field">
                  <span>{{ 'item.currentPassword' | translate }}</span>
                  <ion-item lines="none">
                    <ion-input formControlName="password"
                      type="password"></ion-input>
                  </ion-item>
                </label>

                <label class="profile-field">
                  <span>{{ 'item.newPassword' | translate }}</span>
                  <ion-item lines="none">
                    <ion-input formControlName="newPassword"
                      type="password"></ion-input>
                  </ion-item>
                </label>

                <label class="profile-field">
                  <span>{{ 'profileWorkspace.security.repeatNewPassword' | translate }}</span>
                  <ion-item lines="none">
                    <ion-input formControlName="newPasswordAgain"
                      type="password"></ion-input>
                  </ion-item>
                </label>

                <button class="profile-button profile-button--primary"
                  type="button"
                  [disabled]="passwordFormGroup().invalid"
                  (click)="updatePassword(passwordFormGroup())">
                  {{ 'general.updatePassword' | translate }}
                </button>
              </form>
            }

            <div class="profile-security__danger">
              <span>{{ 'profileWorkspace.security.destructiveActions' | translate }}</span>
              <button class="profile-button profile-button--danger"
                type="button"
                (click)="delete()">
                {{ 'profileWorkspace.security.deleteAccount' | translate }}
              </button>
            </div>
          </div>
        </article>

        <article class="profile-card">
          <button class="profile-collapse"
            type="button"
            (click)="showAdvanced.set(!showAdvanced())">
            <div>
              <h2>{{ 'profileWorkspace.additional.title' | translate }}</h2>
              <p>{{ 'profileWorkspace.additional.description' | translate }}</p>
            </div>
            <ion-icon [name]="showAdvanced() ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>

          @if (showAdvanced()) {
            <div class="profile-advanced">
              @if (editing() && formGroup(); as profileForm) {
                <div class="profile-edit-grid">
                  <label class="profile-field">
                    <span>{{ 'profileWorkspace.additional.iban' | translate }}</span>
                    <ion-item lines="none">
                      <ion-input [formControl]="control('iban')"></ion-input>
                    </ion-item>
                  </label>

                  <div class="profile-field">
                    <span>{{ 'profileWorkspace.additional.languages' | translate }}</span>
                    <div class="profile-language-list">
                      @for (lang of langs; track lang) {
                        <label class="profile-chip-toggle">
                          <input type="checkbox"
                            [checked]="hasLang(lang)"
                            (change)="onLang($event, lang)" />
                          <span>{{ 'langs.' + lang | translate }}</span>
                        </label>
                      }
                    </div>
                  </div>

                  @if (['worker', 'storage'].includes(user()?.role)) {
                    <div class="profile-qualifications">
                      <label class="profile-toggle-card">
                        <div>
                          <strong>{{ 'profileWorkspace.additional.workSafetyCard' | translate }}</strong>
                        </div>
                        <ion-toggle [formControl]="control('workSafetyCard')"></ion-toggle>
                      </label>
                      <label class="profile-toggle-card">
                        <div>
                          <strong>{{ 'profileWorkspace.additional.workPermit' | translate }}</strong>
                        </div>
                        <ion-toggle [formControl]="control('workingPermit')"></ion-toggle>
                      </label>
                      <label class="profile-toggle-card">
                        <div>
                          <strong>{{ 'profileWorkspace.additional.rateko' | translate }}</strong>
                        </div>
                        <ion-toggle [formControl]="control('rateko')"></ion-toggle>
                      </label>
                    </div>
                  }
                </div>
              } @else {
                <div class="profile-setting-list">
                  @if (user()?.iban) {
                    <div class="profile-setting">
                      <span>{{ 'profileWorkspace.additional.iban' | translate }}</span>
                      <strong>{{ user()?.iban }}</strong>
                    </div>
                  }

                  @if (visibleLanguages().length > 0) {
                    <div class="profile-setting">
                      <span>{{ 'profileWorkspace.additional.languages' | translate }}</span>
                      <div class="profile-summary__chips">
                        @for (lang of visibleLanguages(); track lang) {
                          <span>{{ 'langs.' + lang | translate }}</span>
                        }
                        @if (hiddenLanguageCount() > 0) {
                          <span>+{{ hiddenLanguageCount() }}</span>
                        }
                      </div>
                    </div>
                  }

                  @if (['worker', 'storage'].includes(user()?.role)) {
                    <div class="profile-setting">
                      <span>{{ 'profileWorkspace.additional.qualifications' | translate }}</span>
                      <strong>
                        {{ user()?.workSafetyCard ? ('profileWorkspace.additional.workSafetyCard' | translate) : '' }}
                        {{ user()?.workingPermit ? (' · ' + ('profileWorkspace.additional.workPermit' | translate)) : '' }}
                        {{ user()?.rateko ? (' · ' + ('profileWorkspace.additional.rateko' | translate)) : '' }}
                      </strong>
                    </div>
                  }

                  @if (!user()?.iban && visibleLanguages().length === 0
                && !user()?.workSafetyCard && !user()?.workingPermit && !user()?.rateko) {
                    <div class="profile-empty-state">
                      {{ 'profileWorkspace.additional.empty' | translate }}
                    </div>
                  }
                </div>
                }
            </div>
            }
        </article>
      </div>
    </div>
  </section>
  <div modalFooter>
    @if (editing()) {
      @if (saveError()) {
        <div class="profile-save-error">
          {{ saveError() }}
        </div>
      }
      <button class="dialog-action dialog-action--secondary"
        type="button"
        (click)="onCancel()">
        {{ 'general.cancel' | translate }}
      </button>
      <button class="dialog-action dialog-action--primary"
        type="button"
        [disabled]="false"
        (click)="save()">
        {{ 'general.save' | translate }}
      </button>
    }
  </div>
</app-modal-shell>